import { NgModule } from "@angular/core";
import { NgTCIDatePipe } from "./ng-tci-date.pipe";
import { NgTCITruncatePipe } from "./ng-tci-truncate.pipe";
import { NgTCIObjectNgForPipe } from "./ng-tci-obj-for-arr.pipe";

@NgModule({
  declarations: [NgTCIDatePipe, NgTCITruncatePipe, NgTCIObjectNgForPipe],
  exports: [NgTCIDatePipe, NgTCITruncatePipe, NgTCIObjectNgForPipe]
})
export class NgTCIPipeModule { }
